// src/features/app/appSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import {getSiteConfigs, getStorage, setStorage} from "./storage";

const getAppConfig = async () => {
    const { data } = await axios.get('application.json');
    return data;
};

const getDictionary = async (language) => {
    const { data } = await axios.get(`languages/${language}.json`);
    return data;
};

const isSameNotification = (left, right) => {
    if (left?.documentId && right?.documentId) {
        return String(left.documentId) === String(right.documentId);
    }

    return left?.id !== null
        && left?.id !== undefined
        && right?.id !== null
        && right?.id !== undefined
        && String(left.id) === String(right.id);
};


export const fetchAppData = createAsyncThunk(
    'app/fetchAppData',
    async (_, thunkAPI) => {
        try {
            let config = await getAppConfig();
            const language = getSiteConfigs()&&getSiteConfigs().language?getSiteConfigs().language.code:config.config.language;
            const dictionary = await getDictionary(language);
            config.config['dir']=getSiteConfigs()&&getSiteConfigs().language?getSiteConfigs().language.dir:config.config.dir;
            config.config['language']=getSiteConfigs()&&getSiteConfigs().language?getSiteConfigs().language.code:config.config.language;
            config.config['dark-mode']=getSiteConfigs()&&getSiteConfigs()["dark-mode"]?getSiteConfigs()["dark-mode"]:config.config['dark-mode'];
            return { config, dictionary };
        } catch (error) {
            return thunkAPI.rejectWithValue('Loading Configs Error');
        }
    }
);

const appSlice = createSlice({
    name: 'app',
    initialState: {
        config: null,
        dictionary: null,
        isDeveloper:getStorage("developer"),
        workspaceId:getStorage("workspace"),
        workspaceMembershipData:null,
        workspaceMembershipsData:[],
        workspaceSelectionRequired:false,
        notifications:[],
        pages: [],
        homePageIndex:0,
        isDesktop:window.innerWidth >= 992,
        status: 'idle',
        error: null,
        message:null,
        prompt:null,
    },
    reducers: {
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setWorkspaceMembership: (state, action) => {
            state.workspaceMembershipData = action.payload;
        },
        setWorkspaceMemberships: (state, action) => {
            state.workspaceMembershipsData = action.payload;
        },
        setWorkspaceSelectionRequired: (state, action) => {
            state.workspaceSelectionRequired = Boolean(action.payload);
        },
        setNotifications: (state, action) => {
            state.notifications = action.payload;
        },
        upsertNotification: (state, action) => {
            const item = action.payload;
            if (!item) return;

            const index = state.notifications.findIndex((notification) => isSameNotification(notification, item));
            if (index >= 0) {
                state.notifications[index] = {...state.notifications[index], ...item};
            } else {
                state.notifications.unshift(item);
            }
        },
        removeNotification: (state, action) => {
            const item = action.payload;
            state.notifications = state.notifications.filter((notification) => !isSameNotification(notification, item));
        },
        setWorkspace: (state, action) => {
            state.workspaceId = action.payload;
            setStorage("workspace", action.payload)
        },
        setPrompt: (state, action) => {
            state.prompt = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppData.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAppData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.config = action.payload.config.config;
                state.dictionary = action.payload.dictionary;
                state.pages = action.payload.config.pages;
                const homePageIndex = action.payload.config.pages.findIndex(e=>e.name===action.payload.config.config['home-page']);

                state.homePageIndex = homePageIndex>0?homePageIndex:0;
            })
            .addCase(fetchAppData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export const {
    removeNotification,
    setMessage,
    setNotifications,
    setPrompt,
    setWorkspace,
    setWorkspaceMembership,
    setWorkspaceMemberships,
    setWorkspaceSelectionRequired,
    upsertNotification,
} = appSlice.actions;
export default appSlice.reducer;
